export function getIpcRenderer(): any {
  return (window as any).ipcRenderer;
}
